/**
 * Shared utilities for MemoizedPantryMarker components across platforms.
 */

export const ZINDEX_TOPMOST = 1000;
export const ZINDEX_BOTTOMMOST = 0;

/**
 * Calculates the appropriate zIndex for a marker based on its state.
 * @param {boolean} isActive - Whether the marker is currently selected
 * @param {number|null|undefined} pantryId - The pantry ID from the pantry object
 * @returns {number} The zIndex value for the marker
 */
export function getMarkerZIndex(isActive, pantryId) {
  if (isActive) return ZINDEX_TOPMOST;
  if (pantryId && pantryId > 0) return ZINDEX_BOTTOMMOST + 1;
  return ZINDEX_BOTTOMMOST;
}

/**
 * Extracts the icon URI from an icon source, handling both object and string formats.
 * @param {Object|string|null} iconSource - The icon source from getIcon()
 * @returns {string|null} The URI string for the icon
 */
export function getIconUri(iconSource) {
  if (!iconSource) return null;
  return iconSource?.uri || iconSource;
}
